import React, { useState, useEffect } from "react";
import "./SentimentTag.css";
import { ROOT_ID } from "relay-runtime";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { useTheme, useThemeUpdate } from "../contexts/ThemeContext";
import { hot_colors, cool_colors, neutral_colors } from "../constants";

let id = "";
let value = "";

function SentimentTag(props) {
    const [isChecked, setIsChecked] = useState(false);
    const [isTagClicked, setIsTagClicked] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [selectedValue, setSelectedValue] = useState("");
    // const { tagData } = props.settings;
    const { sentimentPostIdData } = props.settings;
    const theme = useTheme();

    function onTagClick(e) {
        e.preventDefault();
        setIsChecked(!isChecked);
        setIsTagClicked(true);

        id = e.target.dataset.id;
        value = e.target.dataset.post;
        console.log(value);
        updataTagList(id, value);
    }

    function updataTagList(id, value) {
        const tagDataObject = JSON.parse(sentimentPostIdData);
        if (tagDataObject[id]) {
            delete tagDataObject[id];
            let tagDataString = JSON.stringify(tagDataObject);
            commitLocalUpdate(environment, (store) => {
                const record = store.getRoot().getLinkedRecord("settings");
                record.setValue(tagDataString, "sentimentPostIdData");
            });
        } else {
            const tagDataObject = JSON.parse(sentimentPostIdData);
            tagDataObject[id] = value;
            let tagDataString = JSON.stringify(tagDataObject);

            commitLocalUpdate(environment, (store) => {
                const record = store.getRoot().getLinkedRecord("settings");
                record.setValue(tagDataString, "sentimentPostIdData");
            });
        }
    }

    function getColor(sentiment) {
        if (sentiment < 0) {
            if (sentiment < -0.5) {
                return hot_colors["red300"];
            } else {
                return hot_colors["yellow300"];
            }
        } else {
            if (sentiment > 0) {
                if (sentiment > 0.5) {
                    return cool_colors["purple000"];
                } else {
                    return cool_colors["green000"];
                }
            }
        }

        if (sentiment == 0) {
            return neutral_colors["gray"];
        }
    }

    useEffect(() => {
        if (isTagClicked) {
            // console.log(tagData);
        }
    });

    let highlight = isChecked ? "checked" : "not-checked";
    return (
        <div className="tag-btn-container">
            <div
                id={`tag-btn`}
                className={`sentiment-post-btn theme-${theme.paragraph} theme-${theme.tagOverlay}-${highlight}`}
            >
                {/* <span */}
                {/*     className="post-title" */}
                {/*     data-value={props.value} */}
                {/*     data-id={props.id} */}
                {/*     data-post={props.postId} */}
                {/*     onClick={onTagClick} */}
                {/*     style={{ color: getColor(props.sentiment) }} */}
                {/* > */}
                {/*     {props.value} */}
                {/* </span> */}

                <div
                    style={{
                        height: "10px",
                        width: "10px",
                        backgroundColor: getColor(props.sentiment),
                        borderRadius: "5000px",
                        marginRight: "0.5rem",
                    }}
                >
                    {" "}
                </div>

                <span
                    className="post-title"
                    data-value={props.value}
                    data-id={props.id}
                    data-post={props.postId}
                    onClick={onTagClick}
                >
                    {props.value}
                </span>
                {/* <span>{" | " + props.postReleased}</span> */}
            </div>
        </div>
    );
}

export default SentimentTag;
